.title {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
}
.globe {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5;
}
